export default __webpack_public_path__ + "static/media/Bangles.c7d680b7.jpg";